import { BCMSStateManagerCRUD, BCMSRecord, useBCMSContext } from "bcms-react";
import TemplateDetailsPage, { getDefaultData, getDefaultUI } from 'components/pages/TemplateDetailsPage';
import Classes, { CompanyAccount, ACHFromAccount, Account } from "model";

export default function CaptureTemplateDetailsACHParticipantsGroupNameEntered(props) {
  const context = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, context);

  const achFromAccount = ACHFromAccount.init({ account: Account.initByID(5).id, id: ACHFromAccount.nextID() });

  const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update(["template", "transactionType"], "payment")
    .update(["template", "secCode"], "PPD Credit - Consumer Credit")
    .update(["template", "name"], "New Payroll")
    .update(["template", "companyDiscretionaryData"], "Bi-Weekly")
    .update(["template", "companyEntryDescription"], "Payroll")
    .update(["template", "companyAccount"], CompanyAccount.initByID(0))
    .update(["achFromAccounts", "accounts"], [achFromAccount])
    .update(["groupSearchValue"], "Employee")
    .submit();

  const ui = BCMSStateManagerCRUD.init(getDefaultUI())
    .update(["showSecCode", "isActive"], true)
    .update(["showOneTimeACHModal", "isActive"], false)
    .update(["achParticipantsModalIsOpen", "isActive"], true)
    .submit();

  return (
    <TemplateDetailsPage ui={ui} data={data} />
  )
}
